<div class="page-403-container">
  <img [src]="imageUrl" alt="403" class="page-403-image" cpakErrorImage />
  <div class="page-403-title">
    {{ (routeQueryParams | async)?.['error_description'] || ('page403Text' | transloco) }}
  </div>
  <button
    *ngIf="(isLoginFailed$ | async) === false"
    pButton
    type="button"
    [label]="'page403RedirectToDashboard' | transloco"
    [routerLink]="['/' + dashboardLink]"
    class="p-button primary-button p-button-rounded page-403-button"
  ></button>
</div>
